module.exports = __webpack_public_path__ + "static/media/Survivor.3d98a59c.png";